import { LineSegments, Material, Mesh, Points, SphereGeometry, Sprite } from "three";
import { BaseObject } from "./BaseObject";
export class PanoramaObject {
    constructor(object) {
        this.opacity = 1;
        this.visible = true;
        this.object = object;
    }
    getRotation(rotation) {
        if (rotation === undefined) {
            return {
                x: this.object.quaternion.x,
                y: this.object.quaternion.y,
                z: this.object.quaternion.z,
                w: this.object.quaternion.w,
            };
        }
        else {
            rotation.x = this.object.quaternion.x;
            rotation.y = this.object.quaternion.y;
            rotation.z = this.object.quaternion.z;
            rotation.w = this.object.quaternion.w;
            return rotation;
        }
    }
    setRotation(rotation) {
        this.object.quaternion.x = rotation.x;
        this.object.quaternion.y = rotation.y;
        this.object.quaternion.z = rotation.z;
        this.object.quaternion.w = rotation.w;
    }
    setRotationCartographic(cartographic, heading) {
        BaseObject.setObjectRotationCartographic(this, cartographic, heading);
    }
    getOpacity() {
        return this.opacity;
    }
    setOpacity(value) {
        if (this.object.material instanceof Material) {
            this.object.material.opacity = value;
            this.object.material.transparent = true;
            this.object.material.needsUpdate = true;
        }
        else {
            for (const material of this.object.material) {
                material.opacity = value;
                material.transparent = true;
                material.needsUpdate = true;
            }
        }
        this.opacity = value;
    }
    getPriority() {
        return this.object.renderOrder;
    }
    setPriority(value) {
        this.object.renderOrder = value;
    }
    getVisible() {
        return this.visible;
    }
    setVisible(visible) {
        this.visible = visible;
    }
    dispose() {
        this.object.traverse((v) => {
            if (v instanceof Mesh || v instanceof Points || v instanceof LineSegments || v instanceof Sprite) {
                if (v.geometry) {
                    v.geometry.dispose();
                }
                if (v.material) {
                    if (v.material.map)
                        v.material.map.dispose();
                    if (v.material.lightMap)
                        v.material.lightMap.dispose();
                    if (v.material.bumpMap)
                        v.material.bumpMap.dispose();
                    if (v.material.normalMap)
                        v.material.normalMap.dispose();
                    if (v.material.specularMap)
                        v.material.specularMap.dispose();
                    if (v.material.envMap)
                        v.material.envMap.dispose();
                    if (v.material.alphaMap)
                        v.material.alphaMap.dispose();
                    if (v.material.aoMap)
                        v.material.aoMap.dispose();
                    if (v.material.displacementMap)
                        v.material.displacementMap.dispose();
                    if (v.material.emissiveMap)
                        v.material.emissiveMap.dispose();
                    if (v.material.gradientMap)
                        v.material.gradientMap.dispose();
                    if (v.material.metalnessMap)
                        v.material.metalnessMap.dispose();
                    if (v.material.roughnessMap)
                        v.material.roughnessMap.dispose();
                    v.material.dispose();
                }
            }
        });
    }
}
PanoramaObject.GEOMETRY = geomInit();
function geomInit() {
    const geometry = new SphereGeometry(500, 60, 40);
    geometry.scale(-1, 1, 1);
    return geometry;
}
